import { get } from "./api";

export async function getMyUserToken() {
  const response = await get({ path: `/developer-apps/user/access-token` });
  return response.data;
}
